import
{
  Container,
  NameText,
} from './NameAvatar.styles';
import ClubLogoAvatar from '../ClubLogoAvatar/ClubLogoAvatar';
import { Skeleton } from '@mui/material';

const NameAvatar = ({ image, name }) =>
{
  return (
    <Container>
      <ClubLogoAvatar
        clubLogo={image}
        small
      />
      <NameText>
        {(name == "loading") ?
          <Skeleton width={100}></Skeleton>
          :
          name}
      </NameText>
    </Container>
  );
};

export default NameAvatar;
